import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';


@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  isLoggedIn = false;
  constructor(public firebaseAuth: AngularFireAuth, private firestore: AngularFirestore) { }

  async signin(email: string, password:string){

    await this.firebaseAuth.signInWithEmailAndPassword(email, password)
    .then(res=>{
      this.isLoggedIn = true;
      localStorage.setItem('user',JSON.stringify(res.user))
    })
  }

  async signup(email: string, password: string){
    await this.firebaseAuth.createUserWithEmailAndPassword(email,password)
    .then(res=>{
      this.isLoggedIn = true;
      localStorage.setItem('user',JSON.stringify(res.user))
    })
  }

  
logout(){
  this.firebaseAuth.signOut();
  localStorage.removeItem('user')
}

sendMessage(messageDetails: any){
  return this.firestore.collection('messageDetails').add(messageDetails);
}

getMessage() {
  return this.firestore.collection('messageDetails').snapshotChanges();
}

deleteMessage(id: string) {
  // this.firestore.doc('imageDetails/' + id).delete();
  return this.firestore.collection("messageDetails").doc(id).delete();
}

}
